import React, {useState, useEffect} from "react";
import Details from "../modals/details";
import Appointment from "../modals/appointment";
import Upload from "../modals/upload";
import Select from "react-select";
import Feedback from "../modals/feedback";
import Info from "../modals/info";
import { AdminStatus } from "../statuses";
import { API } from "../../api-service";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import Button from 'react-bootstrap/esm/Button';
import fontawesome from '@fortawesome/fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleInfo} from '@fortawesome/free-solid-svg-icons';

export default function Layout(props){

    const [detailsShow, setDetailsShow] = useState(false);
    const [feedbackShow, setFeedbackShow] = useState(false);
    const [appointShow, setAppointShow] = useState(false);
    const [uploadShow, setUploadShow] = useState(false);
    const [nurse, setNurse] = useState(null);

    fontawesome.library.add(faCircleInfo);

    const assignClicked = () => {
        if (nurse){
            alert(`Case ${props.cases[props.caseIndex].reference_no} assigned to ${nurse.value}.`);
            let newCase = props.cases[props.caseIndex];
            newCase.completed_by = nurse.userid;
            newCase.completed_by_id = nurse.userid;
            newCase.date_assigned = format(new Date(), "yyyy-MM-dd HH:mm");
            newCase.status = AdminStatus.assigned.key;
            newCase.feedback_status = "Assigned";
            props.setCases(prev => {return [...prev.slice(0, props.caseIndex),
                                            newCase, 
                                            ...prev.slice(props.caseIndex+1)
            ]});
            API.updateCase(props.cases[props.caseIndex].reference_no, newCase, props.token['pn-token']);
        }
        else{
            alert("Please select a nurse.");
        }
    }

    const unassignClicked = () => {
        alert(`Case ${props.cases[props.caseIndex].reference_no} unassigned.`);
        let newCase = props.cases[props.caseIndex];
        newCase.completed_by = null;
        newCase.completed_by_id = null;
        newCase.date_assigned = null;
        newCase.status = AdminStatus.new.key;
        newCase.feedback_status = "Unassigned";
        props.setCases(prev => {return [...prev.slice(0, props.caseIndex),
                                        newCase, 
                                        ...prev.slice(props.caseIndex+1)
        ]});
        API.updateCase(props.cases[props.caseIndex].reference_no, newCase, props.token['pn-token']);
    }

    const detailsClicked = () => {
        setDetailsShow(true);
    }

    const feedbackClicked = () => {
        setFeedbackShow(true);
    }

    const appointClicked = () => {
        setAppointShow(true);
    }

    const completedClicked = () => {
        alert(`Appointment for case ${props.cases[props.caseIndex].reference_no} completed.`);
        let newCase = props.cases[props.caseIndex];
        newCase.appointment_completion_date = format(new Date(), "yyyy-MM-dd HH:mm");
        newCase.status = AdminStatus.aptcomp.key;
        newCase.feedback_status = "Appointment Completed";
        newCase.feedback_message = "";
        props.setCases(prev => {return [...prev.slice(0, props.caseIndex),
                                        newCase, 
                                        ...prev.slice(props.caseIndex+1)
        ]});
        API.updateCase(props.cases[props.caseIndex].reference_no, newCase, props.token['pn-token']);
    }

    const uploadClicked = () => {
        setUploadShow(true);
    }

    const reopenClicked = () => {
        console.log("Reopen");
    }

    const deleteClicked = () => {
        console.log("Delete");
    }

    const nurseChanged = nurse => {
        setNurse(nurse);
    }

    if(props.nurse){
        switch(props.status){
            case AdminStatus.assigned.key:
                return (
                    <>
                        <Info show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Info>
                        <Feedback show={feedbackShow} onHide={() => setFeedbackShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <Appointment show={appointShow} onHide={() => setAppointShow(false)} token={props.token} cases={props.cases} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_phone}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_firstname} {props.cases[props.caseIndex].patient_lastname}</div>
                        <Button variant="outline-dark" className="case-button" onClick={() => appointClicked(props.cases[props.caseIndex])}>Create Appointment</Button>
                        <Button variant="outline-dark" className="case-button" onClick={() => feedbackClicked(props.cases[props.caseIndex])}>Edit Feedback</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case (AdminStatus.aptmade.key) :
                return(
                    <>
                        <Info show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Info>
                        <Feedback show={feedbackShow} onHide={() => setFeedbackShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <Appointment show={appointShow} onHide={() => setAppointShow(false)} token={props.token} cases={props.cases} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].test_type} - <br/>{props.cases[props.caseIndex].test_details}</div>
                        <div className='col'>{new Date(props.cases[props.caseIndex].appointment_date).getTime() + 86.4e6 - new Date().getTime() >= 0?
                                    <div className="action-text">{props.cases[props.caseIndex].appointment_date} {props.cases[props.caseIndex].appointment_time}</div>:
                                    <div className="action-text">Appointment date elapsed.</div>}
                        </div>
                        <Button variant="outline-dark" className="case-button" onClick={() => completedClicked(props.cases[props.caseIndex])}>Mark Completed</Button>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <Button variant="outline-dark" className="case-button" onClick={() => appointClicked(props.cases[props.caseIndex])}>Reschedule Appointment</Button>
                            <Button variant="outline-dark" className="case-button" onClick={() => feedbackClicked(props.cases[props.caseIndex])}>Edit Feedback</Button>
                        </div>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case (AdminStatus.aptresc.key) :
                return(
                    <>
                        <Info show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Info>
                        <Feedback show={feedbackShow} onHide={() => setFeedbackShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <Appointment show={appointShow} onHide={() => setAppointShow(false)} token={props.token} cases={props.cases} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].test_type} - <br/>{props.cases[props.caseIndex].test_details}</div>
                        <div className='col'>{new Date(props.cases[props.caseIndex].appointment_date).getTime() + 86.4e6 - new Date().getTime() >= 0?
                                    <div className="action-text">{props.cases[props.caseIndex].appointment_date} {props.cases[props.caseIndex].appointment_time}</div>:
                                    <div className="action-text">Appointment date elapsed.</div>}
                        </div>
                        <Button variant="outline-dark" className="case-button" onClick={() => completedClicked(props.cases[props.caseIndex])}>Mark Completed</Button>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <Button variant="outline-dark" className="case-button" onClick={() => appointClicked(props.cases[props.caseIndex])}>Reschedule Appointment</Button>
                            <Button variant="outline-dark" className="case-button" onClick={() => feedbackClicked(props.cases[props.caseIndex])}>Edit Feedback</Button>
                        </div>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case AdminStatus.aptcomp.key:
                return(
                    <>
                        <Info show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Info>
                        <Upload show={uploadShow} onHide={() => setUploadShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <Feedback show={feedbackShow} onHide={() => setFeedbackShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_firstname}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_lastname}</div>
                        <div className='col'>{props.cases[props.caseIndex].test_type} - <br/>{props.cases[props.caseIndex].test_details}</div>
                        <Button variant="outline-dark" className="case-button" onClick={() => uploadClicked(props.cases[props.caseIndex])}>Upload Report</Button>
                        <Button variant="outline-dark" className="case-button" onClick={() => feedbackClicked(props.cases[props.caseIndex])}>Edit Feedback</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            default:
                return(
                    <>
                        <div className='case-text 1'>{props.cases[props.caseIndex].reference_no}</div>
                        <div className='case-text 2'>{props.cases[props.caseIndex].patient_add1 != "nan"? props.cases[props.caseIndex].patient_add1:""}</div>
                        <div className='case-text 3'>{props.cases[props.caseIndex].patient_add2 != "nan"? props.cases[props.caseIndex].patient_add2:""}</div>
                        <div className='case-text 4'>{props.cases[props.caseIndex].insurance_company != "nan"? props.cases[props.caseIndex].insurance_company:""}</div>
                        <span></span>
                        <div className='caseactions'>
                            <Info show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Info>
                            <Feedback show={feedbackShow} onHide={() => setFeedbackShow(false)} case={props.cases[props.caseIndex]}></Feedback>
                            <Appointment show={appointShow} onHide={() => setAppointShow(false)} case={props.cases[props.caseIndex]} token={props.token}></Appointment>
                            <Upload show={uploadShow} onHide={() => setUploadShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                            <div className="action-space three-button">
                                <Button variant="outline-dark" className="case-button" onClick={() => appointClicked(props.cases[props.caseIndex])}>Create Appointment</Button>
                                <span></span>
                                <Button variant="outline-dark" className="case-button" onClick={() => uploadClicked(props.cases[props.caseIndex])}>Upload Report</Button>
                                <span></span>
                                <Button variant="outline-dark" className="case-button" onClick={() => feedbackClicked(props.cases[props.caseIndex])}>Edit Feedback</Button>
                            </div>
                            <span></span>
                            <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                        </div>
                    </>
                )
        }
    }
    else{
        switch(props.status){
            case AdminStatus.new.key:
                return (
                    <>
                        <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='col'>{format(parseISO(props.cases[props.caseIndex].date_received), "yyyy/MM/dd HH:mm")}</div>
                        
                        <Select className="dropdown" onChange={nurse => nurseChanged(nurse)} 
                                value={nurse? nurse: null} 
                                options={props.nurseList} placeholder="Select Nurse to Assign" isClearable isSearchable={false}/>
                        <Button variant="outline-dark" className="case-button" onClick={() => assignClicked()}>Assign</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked()}/>
                    </>
                    
                )
            case AdminStatus.assigned.key:
                return (
                    <>
                        <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='col'>{format(parseISO(props.cases[props.caseIndex].date_received), "yyyy/MM/dd HH:mm")}</div>
                        {/* <div className='col'>{props.cases[props.caseIndex].patient_phone}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_phone}</div> */}
                        <div className="action-text">Assigned to {(props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id)?
                                                                            props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id):
                                                                            {'value':0}).value}
                        </div>
                        <Button variant="outline-dark" className="case-button" onClick={unassignClicked}>Unassign</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case AdminStatus.aptmade.key:
                return(
                    <>
                        <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='col'>{props.cases[props.caseIndex].appointment_date} {props.cases[props.caseIndex].appointment_time}</div>
                        <div className="action-text">Assigned to {(props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id)?
                                                                                props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id):
                                                                                {'value':0}).value}
                        </div>
                        <Button variant="outline-dark" className="case-button" onClick={unassignClicked}>Unassign</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case AdminStatus.aptresc.key:
                return(
                    <>
                        <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='col'>{props.cases[props.caseIndex].appointment_date} {props.cases[props.caseIndex].appointment_time}</div>
                        <div className="action-text">Assigned to {(props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id)?
                                                                                props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id):
                                                                                {'value':0}).value}
                        </div>
                        <Button variant="outline-dark" className="case-button" onClick={unassignClicked}>Unassign</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case AdminStatus.aptcomp.key:
                return(
                    <>
                        <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                        <Upload show={uploadShow} onHide={() => setUploadShow(false)} cases={props.cases} token={props.token} caseIndex={props.caseIndex} setCases={props.setCases}/>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='col'>{format(parseISO(props.cases[props.caseIndex].appointment_completion_date), "yyyy/MM/dd HH:mm")}</div>
                        <div className="action-text">Assigned to {(props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id)?
                                                                                props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id):
                                                                                {'value':0}).value}
                        </div>
                        <Button variant="outline-dark" className="case-button" onClick={() => uploadClicked(props.cases[props.caseIndex])}>Upload Report</Button>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case AdminStatus.completed.key:
                return(
                    <>
                        <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='col'>{props.cases[props.caseIndex].insurance_company != "nan"? props.cases[props.caseIndex].insurance_company:""}</div>
                        <div className="action-text">Done by {(props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id)?
                                                                                props.nurseList.find(x => x.userid == props.cases[props.caseIndex].completed_by_id):
                                                                                {'value':0}).value}
                        </div>
                        <a href={props.cases[props.caseIndex].report_url} target="_blank">report link</a>
                        <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                    </>
                )
            case AdminStatus.closed.key:
                return(
                    <>
                        <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='case-text 4'>{props.cases[props.caseIndex].insurance_company != "nan"? props.cases[props.caseIndex].insurance_company:""}</div>
                        <span></span>
                        <div className='caseactions'>
                            <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                            <div className="action-space">
                                <div/>
                            </div>
                            <span></span>
                            <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                        </div>
                    </>
                )
            default:
                return(
                    <>
                       <div className='col'>{props.cases[props.caseIndex].reference_no}<br/>{props.cases[props.caseIndex].policy_number}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_add}</div>
                        <div className='col'>{props.cases[props.caseIndex].patient_town}, {props.cases[props.caseIndex].patient_province}</div>
                        <div className='case-text 4'>{props.cases[props.caseIndex].insurance_company != "nan"? props.cases[props.caseIndex].insurance_company:""}</div>
                        <span></span>
                        <div className='caseactions'>
                            <Details show={detailsShow} onHide={() => setDetailsShow(false)} case={props.cases[props.caseIndex]}></Details>
                            <div className="assign"></div>
                            <span></span>
                            <FontAwesomeIcon className="details" icon="circle-info" onClick={() => detailsClicked(props.cases[props.caseIndex])}/>
                        </div>
                    </>
                )
        }
    }
}